import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFilterAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 5.75C3.58579 5.75 3.25 6.08579 3.25 6.5C3.25 6.91421 3.58579 7.25 4 7.25H20C20.4142 7.25 20.75 6.91421 20.75 6.5C20.75 6.08579 20.4142 5.75 20 5.75H4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.75 12.5C5.75 12.0858 6.08579 11.75 6.5 11.75H17.5C17.9142 11.75 18.25 12.0858 18.25 12.5C18.25 12.9142 17.9142 13.25 17.5 13.25H6.5C6.08579 13.25 5.75 12.9142 5.75 12.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.25 18.5C7.25 18.0858 7.58579 17.75 8 17.75H16C16.4142 17.75 16.75 18.0858 16.75 18.5C16.75 18.9142 16.4142 19.25 16 19.25H8C7.58579 19.25 7.25 18.9142 7.25 18.5Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconFilterAlt as ReactComponent };
